import KTWizard from '../../../../theme/_assets/js/wizard';
import React, { Component } from "react";
import { Button,Card,Breadcrumb,Form,Table,ButtonGroup,ButtonToolbar } from "react-bootstrap";
import Select from 'react-select';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';
import { Col, CardBody } from "reactstrap";

var CryptoJS = require("crypto-js");
let key = process.env.REACT_APP_CRYPTO_KEY
var wizard = null;

class TankCreate extends Component {

  constructor(props) {
    super(props);
    this.state = {
		tankId: this.props.location.data ? this.props.location.data : this.props.location.state.data ? this.props.location.state.data : 0,
		customerType: "",
		customerCode: "",
		tankType: "",
		tankShapeDimension: "",
		tankCapacity: "",
		tankHeight: "",
		tankLength: "",
		tankWidth: "",
		contactPerson1: "",
		phoneNumber1: "",
		emailAddress1: "",
		contactPerson2: "",
		phoneNumber2: "",
		emailAddress2: "",
		contactPerson3: "",
		phoneNumber3: "",
		emailAddress3: "",
		deviceId: "",
		propertyId: "",
		simType: "",
		simNumber: "",
		sensors1: "",
		feetLevel1: "",
		waterLevel1: "",
		description1: "",
		sensors2: "",
		feetLevel2: "",
		waterLevel2: "",
		description2: "",
		sensors3: "",
		feetLevel3: "",
		waterLevel3: "",
		description3: "",
		sensors4: "",
		feetLevel4: "",
		waterLevel4: "",
		description4: "",
		sensors5: "",
		feetLevel5: "",
		description5: "",
		sensors6: "",
		feetLevel6: "",
		waterLevel6: "",
		description6: "",
		sensors7: "",
		feetLevel7: "",
		waterLevel7: "",
		description7: "",
		sensors8: "",
		feetLevel8: "",
		waterLevel8: "",
		description8: "",
		sensors9: "",
		feetLevel9: "",
		waterLevel9: "",
		description9: "",
		sensors10: "",
		feetLevel10: "",
		waterLevel10: "",
		description10: "",
		flowMeterdeviceId: "",
		powerBackupAdded: "",
		powerBackupType: "",
		powerBackupDeviceId: "",
		canshowsensor: "block"
	};
    this.submit = this.submit.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.modalToggle = this.modalToggle.bind(this);
    this.KTWizard = React.createRef();
    this.validator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
  }

  modalToggle = () => {
    this.setState({ showModal: !this.state.showModal });
  }


  leaveHandle = (event) => {
    event.preventDefault();
    this.validator.showMessageFor(event.target.name)
    const { id, value } = event.target;
    let errors = this.state.errors;

    switch (id) {
      case 'upassword':
        errors.password =
          value.length < 8
            ? 'Password must be 8 characters long!'
            : '';
        if (value.length < 8) {
          this.setState({ passLength: true });
        }
        else {
          this.setState({ passLength: false });
        }
        break;
      default:
        break;
    }

    this.setState({ errors, [id]: value }, () => {
    })
  }

  componentDidMount() {

    wizard = new KTWizard(this.KTWizard.current, {
      startStep: 1,
      clickableSteps: true
    });


    fetch(process.env.REACT_APP_NODE_ENV + "/api/master/fetchAllApartmentType", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    })
      .then(res => res.json())
      .then(data => { this.setState({ apartmentTypes: data }) })
      .catch(error => this.setState({ apartmentTypes: [] }))

    fetch(process.env.REACT_APP_NODE_ENV + "/api/master/fetchAllCity", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    })
      .then(res => res.json())
      .then(data => { this.setState({ cities: data }) })
      .catch(error => this.setState({ cities: [] }))

      const url = process.env.REACT_APP_NODE_ENV + "/api/apart-customer/fetchAll/"
      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
          if (!response.ok) throw new Error(response.status);
          else return response.json();
        }
      ).then(data => {
        this.setState({ apartmentUserInput: data });
      }).catch(error => this.setState({ apartmentUserInput: [] }))

      const url2 = process.env.REACT_APP_NODE_ENV + "/api/corp-customer/fetchAll/"
      fetch(url2, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
          if (!response.ok) throw new Error(response.status);
          else return response.json();
        }
      ).then(data => {
        this.setState({ corporateUserInput: data });
      }).catch(error => this.setState({ corporateUserInput: [] }))
	  
      const url3 = process.env.REACT_APP_NODE_ENV + "/api/indiv-customer/fetchAll/"
      fetch(url3, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
          if (!response.ok) throw new Error(response.status);
          else return response.json();
        }
      ).then(data => {
        this.setState({ individualUserInput: data });
      }).catch(error => this.setState({ individualUserInput: [] }))
	
	 let postUserData = {
        tankId: this.state.tankId
      };
	  
      fetch(process.env.REACT_APP_NODE_ENV + '/api/iot/gettankbyid', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        },
        body: JSON.stringify(postUserData)
      }).then((response) => {
        if (response.status === 400) {
          this.setState({ throwUserError: true })
        }
        else { return response.json() }
      })
        .then((data) => {
			console.log(data.customerType)
			console.log(data.contactPerson1)
			if(data.propertyId === 'Ultrasonic')
			{
				this.setState({ 
					customerType: data.customerType,
					customerCode: data.customerCode,
					tankType: data.tankType,
					tankShapeDimension: data.tankShapeDimension,
					tankCapacity: data.tankCapacity,
					tankHeight: data.tankHeight,
					tankLength: data.tankLength,
					tankWidth: data.tankWidth,
					contactPerson1: data.contactPerson1,
					phoneNumber1: data.phoneNumber1,
					emailAddress1: data.emailAddress1,
					contactPerson2: data.contactPerson2,
					phoneNumber2: data.phoneNumber2,
					emailAddress2: data.emailAddress2,
					contactPerson3: data.contactPerson3,
					phoneNumber3: data.phoneNumber3,
					emailAddress3: data.emailAddress3,
					deviceId: data.deviceId,
					propertyId: data.propertyId,
					simType: data.simType,
					simNumber: data.simNumber,
					sensors1: data.sensors1,
					feetLevel1: data.tankHeight,
					waterLevel1: data.waterLevel1,
					description1: data.description1,
					sensors2: data.sensors2,
					feetLevel2: data.feetLevel2,
					waterLevel2: data.waterLevel2,
					description2: data.description2,
					sensors3: data.sensors3,
					feetLevel3: data.feetLevel3,
					waterLevel3: data.waterLevel3,
					description3: data.description3,
					sensors4: data.sensors4,
					feetLevel4: data.feetLevel4,
					waterLevel4: data.waterLevel4,
					description4: data.description4,
					sensors5: data.sensors5,
					feetLevel5: data.feetLevel5,
					waterLevel5: data.waterLevel5,
					description5: data.description5,
					sensors6: data.sensors6,
					feetLevel6: data.feetLevel6,
					waterLevel6: data.waterLevel6,
					description6: data.description6,
					sensors7: data.sensors7,
					feetLevel7: data.feetLevel7,
					waterLevel7: data.waterLevel7,
					description7: data.description7,
					sensors8: data.sensors8,
					feetLevel8: data.feetLevel8,
					waterLevel8: data.waterLevel8,
					description8: data.description8,
					sensors9: data.sensors9,
					feetLevel9: data.feetLevel9,
					waterLevel9: data.waterLevel9,
					description9: data.description9,
					sensors10: data.sensors10,
					feetLevel10: data.feetLevel10,
					waterLevel10: data.waterLevel10,
					description10: data.description10,
					flowMeterdeviceId: data.flowMeterdeviceId,
					powerBackupAdded: data.powerBackupAdded,
					powerBackupType: data.powerBackupType,
					powerBackupDeviceId: data.powerBackupDeviceId,
					enableiotnotifications: data.enableiotnotifications,
					enableflowmeternotifications: data.enableflowmeternotifications,
					canshowsensor: "none",
				})
			}else{
				this.setState({ 
					customerType: data.customerType,
					customerCode: data.customerCode,
					tankType: data.tankType,
					tankShapeDimension: data.tankShapeDimension,
					tankCapacity: data.tankCapacity,
					tankHeight: data.tankHeight,
					tankLength: data.tankLength,
					tankWidth: data.tankWidth,
					contactPerson1: data.contactPerson1,
					phoneNumber1: data.phoneNumber1,
					emailAddress1: data.emailAddress1,
					contactPerson2: data.contactPerson2,
					phoneNumber2: data.phoneNumber2,
					emailAddress2: data.emailAddress2,
					contactPerson3: data.contactPerson3,
					phoneNumber3: data.phoneNumber3,
					emailAddress3: data.emailAddress3,
					deviceId: data.deviceId,
					propertyId: data.propertyId,
					simType: data.simType,
					simNumber: data.simNumber,
					sensors1: data.sensors1,
					feetLevel1: data.feetLevel1,
					waterLevel1: data.waterLevel1,
					description1: data.description1,
					sensors2: data.sensors2,
					feetLevel2: data.feetLevel2,
					waterLevel2: data.waterLevel2,
					description2: data.description2,
					sensors3: data.sensors3,
					feetLevel3: data.feetLevel3,
					waterLevel3: data.waterLevel3,
					description3: data.description3,
					sensors4: data.sensors4,
					feetLevel4: data.feetLevel4,
					waterLevel4: data.waterLevel4,
					description4: data.description4,
					sensors5: data.sensors5,
					feetLevel5: data.feetLevel5,
					waterLevel5: data.waterLevel5,
					description5: data.description5,
					sensors6: data.sensors6,
					feetLevel6: data.feetLevel6,
					waterLevel6: data.waterLevel6,
					description6: data.description6,
					sensors7: data.sensors7,
					feetLevel7: data.feetLevel7,
					waterLevel7: data.waterLevel7,
					description7: data.description7,
					sensors8: data.sensors8,
					feetLevel8: data.feetLevel8,
					waterLevel8: data.waterLevel8,
					description8: data.description8,
					sensors9: data.sensors9,
					feetLevel9: data.feetLevel9,
					waterLevel9: data.waterLevel9,
					description9: data.description9,
					sensors10: data.sensors10,
					feetLevel10: data.feetLevel10,
					waterLevel10: data.waterLevel10,
					description10: data.description10,
					flowMeterdeviceId: data.flowMeterdeviceId,
					powerBackupAdded: data.powerBackupAdded,
					powerBackupType: data.powerBackupType,
					powerBackupDeviceId: data.powerBackupDeviceId,
					enableiotnotifications: data.enableiotnotifications,
					enableflowmeternotifications: data.enableflowmeternotifications,
				})
			}
        })
        .catch((error) => console.log(error))
  };

  nextStep() {
	  toast.dismiss();
    
      if (this.validator.allValid()) {       

      }else{
        wizard.goPrev();
        toast.error("Please complete the required basic detail fields !!!", {
          position: toast.POSITION.TOP_CENTER,

        });
        this.validator.showMessages();
      }
    

  }

  prevStep() {
    if (this.state.percentage === 100) return;
    this.setState(prevState => ({ percentage: prevState.percentage - 20 }));
  }

  submit = () => {
        this.setState({ disableSubmit: true });
        const postCustData = {
          "id": this.state.tankId,
          "customerType": this.state.customerType,
          "customerCode": this.state.customerCode,
          "tankType": this.state.tankType,
          "tankShapeDimension": this.state.tankShapeDimension,
          "tankCapacity": this.state.tankCapacity,
          "tankHeight": this.state.tankHeight,
          "tankLength": this.state.tankLength,
          "tankWidth": this.state.tankWidth,
          "contactPerson1": this.state.contactPerson1,
          "phoneNumber1": this.state.phoneNumber1,
          "emailAddress1": this.state.emailAddress1,
          "contactPerson2": this.state.contactPerson2,
          "phoneNumber2": this.state.phoneNumber2,
          "emailAddress2": this.state.emailAddress2,
          "contactPerson3": this.state.contactPerson3,
          "phoneNumber3": this.state.phoneNumber3,
          "emailAddress3": this.state.emailAddress3,
          "deviceId": this.state.deviceId,
          "propertyId": this.state.propertyId,
          "simType": this.state.simType,
          "simNumber": this.state.simNumber,
          "sensors1": this.state.sensors1,
          "feetLevel1": this.state.feetLevel1,
          "waterLevel1": this.state.waterLevel1,
          "description1": this.state.description1,
          "sensors2": this.state.sensors2,
          "feetLevel2": this.state.feetLevel2,
          "waterLevel2": this.state.waterLevel2,
          "description2": this.state.description2,
          "sensors3": this.state.sensors3,
          "feetLevel3": this.state.feetLevel3,
          "waterLevel3": this.state.waterLevel3,
          "description3": this.state.description3,
          "sensors4": this.state.sensors4,
          "feetLevel4": this.state.feetLevel4,
          "waterLevel4": this.state.waterLevel4,
          "description4": this.state.description4,
          "sensors5": this.state.sensors5,
          "feetLevel5": this.state.feetLevel5,
		  "waterLevel5": this.state.waterLevel5,
          "description5": this.state.description5,
          "sensors6": this.state.sensors6,
          "feetLevel6": this.state.feetLevel6,
          "waterLevel6": this.state.waterLevel6,
          "description6": this.state.description6,
          "sensors7": this.state.sensors7,
          "feetLevel7": this.state.feetLevel7,
          "waterLevel7": this.state.waterLevel7,
          "description7": this.state.description7,
          "sensors8": this.state.sensors8,
          "feetLevel8": this.state.feetLevel8,
          "waterLevel8": this.state.waterLevel8,
          "description8": this.state.description8,
          "sensors9": this.state.sensors9,
          "feetLevel9": this.state.feetLevel9,
          "waterLevel9": this.state.waterLevel9,
          "description9": this.state.description9,
          "sensors10": this.state.sensors10,
          "feetLevel10": this.state.feetLevel10,
          "waterLevel10": this.state.waterLevel10,
          "description10": this.state.description10,
          "flowMeterdeviceId": this.state.flowMeterdeviceId,
          "powerBackupAdded": this.state.powerBackupAdded,
          "powerBackupType": this.state.powerBackupType,
          "powerBackupDeviceId": this.state.powerBackupDeviceId,
          "enableiotnotifications": this.state.enableiotnotifications,
          "enableflowmeternotifications": this.state.enableflowmeternotifications,
        };
        fetch(process.env.REACT_APP_NODE_ENV + '/api/iot/updatetank', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
          },
          body: JSON.stringify(postCustData)
        }).then((res) => res.json())
          .then((data) => {
			this.props.history.push({ pathname: "/water-tank/tank-list" });
            toast.success("Tank updated Successfully!!!", {
              position: toast.POSITION.TOP_CENTER,
            });
        }).catch((err) => console.log(err))

  }


  nextPath(path) {
    this.props.history.push(path);
  }


  validUserForm() {
    const { userFirstName, userLastName, userPhoneNumber, userEmail, userPassword, userConPassword } = this.state;
    let validUserFormFlag = false;
    if (userFirstName === '') {
      this.setState({ userFirstNameRequired: true });
      return validUserFormFlag;
    }
    else if (userLastName === '') {
      this.setState({ userLastNameRequired: true });
      return validUserFormFlag;
    }
    else if (userPhoneNumber === '') {
      this.setState({ userPhoneNumberRequired: true });
      return validUserFormFlag;
    }
    else if (userEmail === '') {
      this.setState({ userEmailRequired: true });
      return validUserFormFlag;
    }
    else {
      return true;
    }
  }

  userSubmit = () => {
    if (this.userValidator.allValid()) {
      let postUserData = {
        userFirstName: this.state.userFirstName, userLastName: this.state.userLastName, userPhoneNumber: this.state.userPhoneNumber,
        userEmail: this.state.userEmail, userPassword: this.state.userPassword, userType: "Apartment Customer"
      };
      postUserData = CryptoJS.AES.encrypt(JSON.stringify(postUserData),key).toString()
      fetch(process.env.REACT_APP_NODE_ENV + '/api/users/createUser', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        },
        body: JSON.stringify({ data: postUserData })
      }).then((response) => {
        if (response.status === 400) {
          this.setState({ throwUserError: true })
        }
        else { return response.json() }
      })
        .then((data) => {
          data = CryptoJS.AES.decrypt(data.userData,key)
          data = JSON.parse(data.toString(CryptoJS.enc.Utf8))
          this.setState({ modal: !this.state.modal, pocCustomerId: data.id, pocCustomerName: data.userEmail })
        })
        .catch((error) => console.log(error))
    } else {
      this.userValidator.showMessages();
      this.forceUpdate();
    }

  }
  
handleSelectFormFields = selectedOption => { 
	
	switch (selectedOption.id) {
		case "customerType":
			this.setState({ customerType: selectedOption.value })
			break;
		case "customerCode":
			this.setState({ customerCode: selectedOption.value })
			break;
      default: break;
    }
}

handleChange = (e) => {
	
	switch (e.target.name) {
		case "tankType":
			this.setState({ tankType: e.target.value })
			break;
		case "tankShapeDimension":
			this.setState({ tankShapeDimension: e.target.value })
			break;
		case "tankCapacity":
			this.setState({ tankCapacity: e.target.value })
			break;
		case "tankHeight":
			this.setState({ tankHeight: e.target.value })
			break;
		case "tankLength":
			this.setState({ tankLength: e.target.value })
			break;
		case "tankWidth":
			this.setState({ tankWidth: e.target.value })
			break;
		case "contactPerson1":
			this.setState({ contactPerson1: e.target.value })
			break;
		case "phoneNumber1":
			this.setState({ phoneNumber1: e.target.value })
			break;
		case "emailAddress1":
			this.setState({ emailAddress1: e.target.value })
			break;
		case "contactPerson2":
			this.setState({ contactPerson2: e.target.value })
			break;
		case "phoneNumber2":
			this.setState({ phoneNumber2: e.target.value })
			break;
		case "emailAddress2":
			this.setState({ emailAddress2: e.target.value })
			break;
		case "contactPerson3":
			this.setState({ contactPerson3: e.target.value })
			break;
		case "phoneNumber3":
			this.setState({ phoneNumber3: e.target.value })
			break;
		case "emailAddress3":
			this.setState({ emailAddress3: e.target.value })
			break;		
		case "deviceId":
			this.setState({ deviceId: e.target.value })
			break;
		case "propertyId":
			if(e.target.value === "Ultrasonic"){
				this.setState({ propertyId: e.target.value, canshowsensor: 'none' })
			}else{
				this.setState({ propertyId: e.target.value, canshowsensor: 'block' })
			}
			break;
		case "simType":
			this.setState({ simType: e.target.value })
			break;
		case "simNumber":
			this.setState({ simNumber: e.target.value })
			break;
		case "sensors1":
			this.setState({ sensors1: e.target.value })
			break;
		case "feetLevel1":
			this.setState({ feetLevel1: e.target.value })
			break;
		case "waterLevel1":
			this.setState({ waterLevel1: e.target.value })
			break;
		case "description1":
			this.setState({ description1: e.target.value })
			break;
		case "sensors2":
			this.setState({ sensors2: e.target.value })
			break;
		case "feetLevel2":
			this.setState({ feetLevel2: e.target.value })
			break;
		case "waterLevel2":
			this.setState({ waterLevel2: e.target.value }) 
			break;
		case "description2":
			this.setState({ description2: e.target.value })
			break;
		case "sensors3":
			this.setState({ sensors3: e.target.value })
			break;
		case "feetLevel3":
			this.setState({ feetLevel3: e.target.value })
			break;
		case "waterLevel3":
			this.setState({ waterLevel3: e.target.value })
			break;
		case "description3":
			this.setState({ description3: e.target.value })
			break;
		case "sensors4":
			this.setState({ sensors4: e.target.value })
			break;
		case "feetLevel4":
			this.setState({ feetLevel4: e.target.value })
			break;
		case "waterLevel4":
			this.setState({ waterLevel4: e.target.value })
			break;
		case "description4":
			this.setState({ description4: e.target.value })
			break;
		case "sensors5":
			this.setState({ sensors5: e.target.value })
			break;
		case "feetLevel5":
			this.setState({ feetLevel5: e.target.value })
			break;
		case "waterLevel5":
			this.setState({ waterLevel5: e.target.value })
			break;
		case "description5":
			this.setState({ description5: e.target.value })
			break;
		case "sensors6":
			this.setState({ sensors6: e.target.value })
			break;
		case "feetLevel6":
			this.setState({ feetLevel6: e.target.value })
			break;
		case "waterLevel6":
			this.setState({ waterLevel6: e.target.value })
			break;
		case "description6":
			this.setState({ description6: e.target.value })
			break;
		case "sensors7":
			this.setState({ sensors7: e.target.value })
			break;
		case "feetLevel7":
			this.setState({ feetLevel7: e.target.value })
			break;
		case "waterLevel7":
			this.setState({ waterLevel7: e.target.value })
			break;
		case "description7":
			this.setState({ description7: e.target.value })
			break;
		case "sensors8":
			this.setState({ sensors8: e.target.value })
			break;
		case "feetLevel8":
			this.setState({ feetLevel8: e.target.value })
			break;
		case "waterLevel8":
			this.setState({ waterLevel8: e.target.value })
			break;
		case "description8":
			this.setState({ description8: e.target.value })
			break;
		case "sensors9":
			this.setState({ sensors9: e.target.value })
			break;
		case "feetLevel9":
			this.setState({ feetLevel9: e.target.value })
			break;
		case "waterLevel9":
			this.setState({ waterLevel9: e.target.value })
			break;
		case "description9":
			this.setState({ description9: e.target.value })
			break;
		case "sensors10":
			this.setState({ sensors10: e.target.value })
			break;
		case "feetLevel10":
			this.setState({ feetLevel10: e.target.value })
			break;
		case "waterLevel10":
			this.setState({ waterLevel10: e.target.value })
			break;
		case "description10":
			this.setState({ description10: e.target.value })
			break;
		case "flowMeterdeviceId":
			this.setState({ flowMeterdeviceId: e.target.value })
			break;
		case "powerBackupAdded":
			this.setState({ powerBackupAdded: e.target.value })
			break;
		case "powerBackupType":
			this.setState({ powerBackupType: e.target.value })
			break;
		case "powerBackupDeviceId":
			this.setState({ powerBackupDeviceId: e.target.value })
			break;
		case "enableiotnotifications":
			this.setState({ enableiotnotifications: e.target.value })
			break;
		case "enableflowmeternotifications":
			this.setState({ enableflowmeternotifications: e.target.value })
			break;
		
	  default: break;
    }
}


  render() {
	const customerType = this.state.customerType;
	
	let customerTypeData = [
      { id: "customerType", label: "Apartment Customer", value: "Apartment_Customer" },
           { id: "customerType", label: "Individual Customer", value: "Individual_Customer" },
      { id: "customerType", label: "Corporate Customer", value: "Corporate_Customer" }]
	
	let customerData1 = [];
    if (customerType === "Apartment_Customer") {
		console.log(this.state.apartmentUserInput)
		if(this.state.apartmentUserInput){
			this.state.apartmentUserInput.map(data => {
				if(data.user !== undefined && data.user !== null){
					let sddData = { id: "customerCode", label: data.user.userFirstName +" "+ data.user.userLastName +" ("+data.apartmentId+")", value: data.apartmentId }
						customerData1.push(sddData)
				 }else{
					 let sddData = { id: "customerCode", label: data.apartmentName +" ("+data.apartmentId+")", value: data.apartmentId }
					 customerData1.push(sddData)
				 }
				return null;
			})
		}
    } else if (customerType === "Corporate_Customer") {
		if(this.state.corporateUserInput){
		  this.state.corporateUserInput.map(data => {
			let sddData = { id: "customerCode", label: data.companyName +" ("+data.corporateId+")", value: data.corporateId }
			customerData1.push(sddData)
			return null;
		  })
		}
    } else if (customerType === "Individual_Customer") {
		if(this.state.individualUserInput){
		  this.state.individualUserInput.map(data => {
			let sddData = { id: "customerCode", label: data.firstName +" "+ data.lastName +" ("+data.individualId+")", value: data.individualId}
			customerData1.push(sddData)
			return null;
		  })
		}
    }
  
    return (<>
      <Breadcrumb>
        <Breadcrumb.Item
          onClick={() => this.nextPath("/water-tank/tank-list")}
        >
          Water Tank
          </Breadcrumb.Item>

        <Breadcrumb.Item active>Create Tank</Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <Modal isOpen={this.state.modal} style={{ width: "1000px", display: "block" }}>
          <Card >
            <Card.Body>
              <ModalHeader>
                Add User
                </ModalHeader>
              <ModalBody>
              </ModalBody>
              <ModalFooter><div className="col-8 float-center">
                <Button variant="outline-primary" onClick={this.userSubmit}> Save </Button>
                &nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={this.userToggle}> Cancel </Button>
              </div>
              </ModalFooter>
            </Card.Body>
          </Card>
        </Modal>
      </div>
      <div>
      </div>

      <div ref={this.KTWizard} className="kt-grid kt-wizard-v1 kt-wizard-v1--white" id="kt_wizard_v1" data-ktwizard-state="step-first">
        <div className="kt-grid__item">
          <div className="kt-wizard-v1__nav">
            <div className="kt-wizard-v1__nav-items kt-wizard-v1__nav-items--clickable">
              <div className="kt-wizard-v1__nav-item" data-ktwizard-type="step" data-ktwizard-state="current">
                <div className="kt-wizard-v1__nav-body">
                  <div className="kt-wizard-v1__nav-icon">
                    <i className="flaticon2-list-1"></i>
                  </div>
                  <div className="kt-wizard-v1__nav-label">
                    Tank Details
                </div>
                </div>
              </div>

              <div className="kt-wizard-v1__nav-item" data-ktwizard-type="step">
                <div className="kt-wizard-v1__nav-body">
                  <div className="kt-wizard-v1__nav-icon">
                    <i className="flaticon2-avatar"></i>
                  </div>
                  <div className="kt-wizard-v1__nav-label">
                    IoT Details
                </div>
                </div>
              </div>

              <div className="kt-wizard-v1__nav-item" data-ktwizard-type="step">
                <div className="kt-wizard-v1__nav-body">
                  <div className="kt-wizard-v1__nav-icon">
                    <i className="flaticon2-avatar"></i>
                  </div>
                  <div className="kt-wizard-v1__nav-label">
                    Flow Meter Details
                </div>
                </div>
              </div>

              <div className="kt-wizard-v1__nav-item" data-ktwizard-type="step">
                <div className="kt-wizard-v1__nav-body">
                  <div className="kt-wizard-v1__nav-icon">
                    <i className="flaticon-user-ok"></i>
                  </div>
                  <div className="kt-wizard-v1__nav-label">
                    4. Review and Submit
                </div>
                </div>
              </div>
            </div>
          </div>


        </div>
        {/* <!--begin: Form Wizard Form--> */}
        <div className="kt-grid__item kt-grid__item--fluid kt-wizard-v1__wrapper">
          {/* <!--begin: Form Wizard Form--> */}
          <form className="kt-form" id="kt_form" >

            {/* <!--begin: Form Wizard Step 1--> */}
            <div className="kt-wizard-v1__content" data-ktwizard-type="step-content" data-ktwizard-state="current">
				<div className="kt-heading kt-heading--md">Tank Details </div>
				<div className="kt-form__section kt-form__section--first">
					<div className="kt-wizard-v1__form">
						<div className="form-group row">
							<div className="col-lg-6">
							  <label>Customer Type *</label>
								<Select id="customerType" options={customerTypeData} onChange={this.handleSelectFormFields} value={customerTypeData.filter(obj => obj.value === this.state.customerType)} />
								{
								  this.validator.message('Customer Type', this.state.customerType, 'required')
								}
							</div>

							<div className="col-lg-6">
							 <label>Customer *</label>
								<Select id="customer" options={customerData1} onChange={this.handleSelectFormFields} value={customerData1.filter(obj => obj.value === this.state.customerCode)}/>
								{
								  this.validator.message('Customer', this.state.customerCode, 'required')
								}
							</div>
						</div>
				
						<div className="form-group row">
							<div className="col-lg-6">
							  <label>Tank Type *</label>
								<select className="form-control" name="tankType" id="tankType" onChange={this.handleChange} value={this.state.tankType}>
									<option value="">Select Tank Type</option>
									<option value="Tank">Tank</option>
									<option value="Sump">Sump</option>
								</select>
								{
								  this.validator.message('Tank Type', this.state.tankType, 'required')
								}
							</div>

							<div className="col-lg-6">
							  <label>Tank Shape/Dimension *</label>
							  <input type="text" className="form-control" name="tankShapeDimension" id="tankShapeDimension" placeholder="Tank Shape/Dimension" value={this.state.tankShapeDimension} onChange={this.handleChange}/>
								{
								  this.validator.message('Tank Shape/Dimension', this.state.tankShapeDimension, 'required')
								}
							</div>
						</div>
				  
						<div className="form-group row">
							<div className="col-lg-6">
							  <label>Sump/Tank Capacity (in kl) *</label>
							  <input type="text" className="form-control" name="tankCapacity" id="tankCapacity" placeholder="Sump/Tank Capacity (in kl)" value={this.state.tankCapacity} onChange={this.handleChange} />
								{
								  this.validator.message('Sump/Tank Capacity', this.state.tankCapacity, 'required')
								}
							</div>

							<div className="col-lg-6">
							  <label>Tank Height(ft) *</label>
							  <input type="text" className="form-control" name="tankHeight" id="tankHeight" placeholder="Tank Height(ft)" value={this.state.tankHeight} onChange={this.handleChange} />
								{
								  this.validator.message('Tank Height(ft)', this.state.tankHeight, 'required')
								}
							</div>
						</div>
				
						<div className="form-group row">
							<div className="col-lg-6">
							  <label>Tank Length(ft) *</label>
							  <input type="text" className="form-control" name="tankLength" id="tankLength" placeholder="Tank Length(ft)" value={this.state.tankLength} onChange={this.handleChange} />
								{
								  this.validator.message('Tank Length(ft)', this.state.tankLength, 'required')
								}
							</div>

							<div className="col-lg-6">
							  <label>Tank Width(ft) *</label>
							  <input type="text" className="form-control" name="tankWidth" id="tankWidth" placeholder="Tank Width(ft)" value={this.state.tankWidth} onChange={this.handleChange} />
								{
								  this.validator.message('Tank Width(ft)', this.state.tankWidth, 'required')
								}
							</div>
						</div>
						<div className="form-group row">
							<div className="col-lg-4">
							  <label>Contact Person 1 *</label>
							  <input type="text" className="form-control" name="contactPerson1" id="contactPerson1" placeholder="Contact Person 1" value={this.state.contactPerson1} onChange={this.handleChange} />
								{
								  this.validator.message('Contact Person 1', this.state.contactPerson1, 'required')
								}
							</div>
							<div className="col-lg-4">
							  <label>Phone Number *</label>
							  <input type="text" className="form-control" name="phoneNumber1" id="phoneNumber1" placeholder="Phone Number" value={this.state.phoneNumber1} onChange={this.handleChange} />
								{
								  this.validator.message('Phone Number', this.state.phoneNumber1, 'required')
								}
							</div>
							<div className="col-lg-4">
							  <label>Email Address *</label>
							  <input type="text" className="form-control" name="emailAddress1" id="emailAddress1" placeholder="Email Address" value={this.state.emailAddress1} onChange={this.handleChange} />
								{
								  this.validator.message('Email Address', this.state.emailAddress1, 'required')
								}
							</div>
						</div>
						<div className="form-group row">
							<div className="col-lg-4">
							  <label>Contact Person 2</label>
							  <input type="text" className="form-control" name="contactPerson2" id="contactPerson2" placeholder="Contact Person 2" value={this.state.contactPerson2} onChange={this.handleChange} />
							</div>
							<div className="col-lg-4">
							  <label>Phone Number</label>
							  <input type="text" className="form-control" name="phoneNumber2" id="phoneNumber2" placeholder="Phone Number" value={this.state.phoneNumber2} onChange={this.handleChange} />
							</div>
							<div className="col-lg-4">
							  <label>Email Address</label>
							  <input type="text" className="form-control" name="emailAddress2" id="emailAddress2" placeholder="Email Address" value={this.state.emailAddress2} onChange={this.handleChange} />
							</div>
						</div>
						<div className="form-group row">
							<div className="col-lg-4">
							  <label>Contact Person 3</label>
							  <input type="text" className="form-control" name="contactPerson3" id="contactPerson3" placeholder="Contact Person 3" value={this.state.contactPerson3} onChange={this.handleChange} />
							</div>
							<div className="col-lg-4">
							  <label>Phone Number</label>
							  <input type="text" className="form-control" name="phoneNumber3" id="phoneNumber3" placeholder="Phone Number" value={this.state.phoneNumber3} onChange={this.handleChange} />
							</div>
							<div className="col-lg-4">
							  <label>Email Address</label>
							  <input type="text" className="form-control" name="emailAddress3" id="emailAddress3" placeholder="Email Address" value={this.state.emailAddress3} onChange={this.handleChange} />
							</div>
						</div>
						<div className="form-group row">
 							<div className="col-lg-4">
								<label>Enable IoT Notifications:</label>
								<select className="form-control" name="enableiotnotifications" id="enableiotnotifications" value={this.state.enableiotnotifications} onChange={this.handleChange}>
									<option value="No">No</option>
									<option value="Yes">Yes</option>									
								</select>
							</div>
							<div className="col-lg-4">
								<label>Enable Flow Meter Notifications:</label>
								<select className="form-control" name="enableflowmeternotifications" id="enableflowmeternotifications" value={this.state.enableflowmeternotifications} onChange={this.handleChange}>
									<option value="No">No</option>
									<option value="Yes">Yes</option>	
								</select>
							</div>
						</div>
					</div>
				</div>
            </div>

            {/* <!--end: Form Wizard Step 2--> */}

            {/* <!--begin: Form Wizard Step 3--> */}

            <div className="kt-wizard-v1__content" data-ktwizard-type="step-content">
				<div className="kt-heading kt-heading--md">IoT Details </div>
					<div className="kt-form__section kt-form__section--first">
						<div className="kt-wizard-v1__form">
							<div className="form-group row">
								<div className="col-lg-6">
								  <label>Device Id</label>
								  <input type="text" className="form-control" name="deviceId" id="deviceId" placeholder="Device Id" value={this.state.deviceId} onChange={this.handleChange} />
								</div>

								<div className="col-lg-6">
									<label>Device Type</label>
									<select className="form-control" name="propertyId" id="propertyId" value={this.state.propertyId} onChange={this.handleChange}>
										<option value="">Select</option>
										<option value="Switch">Switch</option>	
										<option value="Ultrasonic">Ultrasonic</option>	
									</select>
								</div>
								
							</div>
						</div>
						<div className="kt-wizard-v1__form">
							<div className="form-group row">
								<div className="col-lg-6">
								  <label>Sim Type</label>
								  <input type="text" className="form-control" name="simType" id="simType" placeholder="Sim Type" value={this.state.simType} onChange={this.handleChange} />
								</div>

								<div className="col-lg-6">
								  <label>Sim Number</label>
								  <input type="text" className="form-control" name="simNumber" id="simNumber" placeholder="Sim Number" value={this.state.simNumber} onChange={this.handleChange} />
								</div>
							</div>
						</div>
						<div className="kt-wizard-v1__form" style={{display:this.state.canshowsensor}}>
							<div className="form-group row">
								<div className="col-lg-3">
								  <label>Sensors</label>
								  <input type="text" className="form-control" name="sensors1" id="sensors1" placeholder="Sensors 1" value={this.state.sensors1} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <label>Feet Level</label>
								  <input type="text" className="form-control" name="feetLevel1" id="feetLevel1" placeholder="Feet Level 1" value={this.state.feetLevel1} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <label>Water Level</label>
								  <input type="text" className="form-control" name="waterLevel1" id="waterLevel1" placeholder="Water Level 1" value={this.state.waterLevel1} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <label>Description</label>
								  <input type="text" className="form-control" name="description1" id="description1" placeholder="Description 1" value={this.state.description1} onChange={this.handleChange} />
								</div>
							</div>
							<div className="form-group row">
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="sensors2" id="sensors2" placeholder="Sensors 2" value={this.state.sensors2} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="feetLevel2" id="feetLevel2" placeholder="Feet Level 2" value={this.state.feetLevel2} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="waterLevel2" id="waterLevel2" placeholder="Water Level 2" value={this.state.waterLevel2} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="description2" id="description2" placeholder="Description 2" value={this.state.description2} onChange={this.handleChange} />
								</div>
							</div>
							<div className="form-group row">
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="sensors3" id="sensors3" placeholder="Sensors 3" value={this.state.sensors3} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="feetLevel3" id="feetLevel3" placeholder="Feet Level 3" value={this.state.feetLevel3} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="waterLevel3" id="waterLevel3" placeholder="Water Level 3" value={this.state.waterLevel3} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="description3" id="description3" placeholder="Description 3" value={this.state.description3} onChange={this.handleChange} />
								</div>
							</div>
							<div className="form-group row">
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="sensors4" id="sensors4" placeholder="Sensors 4" value={this.state.sensors4} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="feetLevel4" id="feetLevel4" placeholder="Feet Level 4" value={this.state.feetLevel4} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="waterLevel4" id="waterLevel4" placeholder="Water Level 4" value={this.state.waterLevel4} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="description4" id="description4" placeholder="Description 4" value={this.state.description4} onChange={this.handleChange} />
								</div>
							</div>
							<div className="form-group row">
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="sensors5" id="sensors5" placeholder="Sensors 5" value={this.state.sensors5} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="feetLevel5" id="feetLevel5" placeholder="Feet Level 5" value={this.state.feetLevel5} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="waterLevel5" id="waterLevel5" placeholder="Water Level 5" value={this.state.waterLevel5} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="description5" id="description5" placeholder="Description 5" value={this.state.description5} onChange={this.handleChange} />
								</div>
							</div>
							<div className="form-group row">
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="sensors6" id="sensors6" placeholder="Sensors 6" value={this.state.sensors6} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="feetLevel6" id="feetLevel6" placeholder="Feet Level 6" value={this.state.feetLevel6} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="waterLevel6" id="waterLevel6" placeholder="Water Level 6" value={this.state.waterLevel6} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="description6" id="description6" placeholder="Description 6" value={this.state.description6} onChange={this.handleChange} />
								</div>
							</div>
							<div className="form-group row">
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="sensors7" id="sensors7" placeholder="Sensors 7" value={this.state.sensors7} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="feetLevel7" id="feetLevel7" placeholder="Feet Level 7" value={this.state.feetLevel7} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="waterLevel7" id="waterLevel7" placeholder="Water Level 7" value={this.state.waterLevel7} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="description7" id="description7" placeholder="Description 7" value={this.state.description7} onChange={this.handleChange} />
								</div>
							</div>
							<div className="form-group row">
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="sensors8" id="sensors8" placeholder="Sensors 8" value={this.state.sensors8} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="feetLevel8" id="feetLevel8" placeholder="Feet Level 8" value={this.state.feetLevel8} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="waterLevel8" id="waterLevel8" placeholder="Water Level 8" value={this.state.waterLevel8} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="description8" id="description8" placeholder="Description 8" value={this.state.description8} onChange={this.handleChange} />
								</div>
							</div>
							<div className="form-group row">
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="sensors9" id="sensors9" placeholder="Sensors 9" value={this.state.sensors9} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="feetLevel9" id="feetLevel9" placeholder="Feet Level 9" value={this.state.feetLevel9} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="waterLevel9" id="waterLevel9" placeholder="Water Level 9" value={this.state.waterLevel9} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="description9" id="description9" placeholder="Description 9" value={this.state.description9} onChange={this.handleChange} />
								</div>
							</div>
							<div className="form-group row">
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="sensors10" id="sensors10" placeholder="Sensors 10" value={this.state.sensors10} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="feetLevel10" id="feetLevel10" placeholder="Feet Level 10" value={this.state.feetLevel10} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="waterLevel10" id="waterLevel10" placeholder="Water Level 10" value={this.state.waterLevel10} onChange={this.handleChange} />
								</div>
								<div className="col-lg-3">
								  <input type="text" className="form-control" name="description10" id="description10" placeholder="Description 10" value={this.state.description10} onChange={this.handleChange} />
								</div>
							</div>							
						</div>
					</div>
				</div>


            {/* <!--end: Form Wizard Step 2--> */}

            {/* <!--begin: Form Wizard Step 3--> */}

            <div className="kt-wizard-v1__content" data-ktwizard-type="step-content">
				<div className="kt-heading kt-heading--md">Flow Meter </div>
					<div className="kt-form__section kt-form__section--first">
						<div className="kt-wizard-v1__form">
							<div className="form-group row">
								<div className="col-lg-6">
								  <label>Device Id</label>
								  <input type="text" className="form-control" name="flowMeterdeviceId" id="flowMeterdeviceId" placeholder="Device Id" value={this.state.flowMeterdeviceId} onChange={this.handleChange} />
								</div>
								<div className="col-lg-6">
								   <label>Power Backup Added</label>
									<select className="form-control" name="powerBackupAdded" id="powerBackupAdded" value={this.state.powerBackupAdded} onChange={this.handleChange}>
										<option value="">Select</option>
										<option value="Yes">Yes</option>
										<option value="No">No</option>
									</select>
								</div>
							</div>
							<div className="form-group row">
								<div className="col-lg-6">
								  <label>Power Backup Type</label>
								  <input type="text" className="form-control" name="powerBackupType" id="powerBackupType" placeholder="Power Backup Type" value={this.state.powerBackupType} onChange={this.handleChange} />
								</div>
								<div className="col-lg-6">
								  <label>Power Backup Device Id</label>
								  <input type="text" className="form-control" name="powerBackupDeviceId" id="powerBackupDeviceId" placeholder="Power Backup Device Id" value={this.state.powerBackupDeviceId} onChange={this.handleChange} />
								</div>
							</div>

						</div>
					</div>
				</div>


            {/* <!--end: Form Wizard Step 3--> */}



            {/* <!--begin: Form Wizard Step 4--> */}
            <div className="kt-wizard-v1__content" data-ktwizard-type="step-content">
              <div className="kt-heading kt-heading--md">Review your Details and Submit</div>
              <div className="kt-form__section kt-form__section--first">
                <div className="kt-wizard-v1__review">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="kt-wizard-v1__review-item">
                        <div className="kt-wizard-v1__review-title">
                          Tank Details
                                                                </div>
                        <div className="kt-wizard-v1__review-content">
                          Tank Type: {this.state.tankType}<br />
                          Tank Shape Dimension: {this.state.tankShapeDimension}<br />
                          Sump/Tank Capacity: {this.state.tankCapacity}<br />
                          Tank Height: {this.state.tankHeight}<br />
                          Tank Length: {this.state.tankLength}<br />
                          Tank Width: {this.state.tankWidth}<br />
                          Contact Person1: {this.state.contactPerson1}<br />
                          Phone Number1: {this.state.phoneNumber1}<br />
                          Email Address1: {this.state.emailAddress1}<br />
                          Contact Person2: {this.state.contactPerson2}<br />
                          Phone Number2: {this.state.phoneNumber2}<br />
                          Email Address2: {this.state.emailAddress2}<br />
                          Contact Person3: {this.state.contactPerson3}<br />
                          Phone Number3: {this.state.phoneNumber3}<br />
                          Email Address3: {this.state.emailAddress3}<br />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="kt-wizard-v1__review-item">
                        <div className="kt-wizard-v1__review-title">
                          IoT Details
                                                                </div>
                        <div className="kt-wizard-v1__review-content">
                          Device Id: {this.state.deviceId} <br />
                          Property Id: {this.state.propertyId} <br />
                          Sim Type: {this.state.simType} <br />
                          Sim Number: {this.state.simNumber} <br />
                          Sensors1: {this.state.sensors1} <br />
                          Feet Level1: {this.state.feetLevel1} <br />
                          Water Level1: {this.state.waterLevel1} <br />
                          Description1: {this.state.description1} <br />
                          Sensors2: {this.state.sensors2} <br />
                          Feet Level2: {this.state.feetLevel2} <br />
                          Water Level2: {this.state.waterLevel2} <br />
                          Description2: {this.state.description2} <br />
						  Sensors3: {this.state.sensors3} <br />
                          Feet Level3: {this.state.feetLevel3} <br />
                          Water Level3: {this.state.waterLevel3} <br />
                          Description3: {this.state.description3} <br />
						  Sensors4: {this.state.sensors4} <br />
                          Feet Level4: {this.state.feetLevel4} <br />
                          Water Level4: {this.state.waterLevel4} <br />
                          Description4: {this.state.description4} <br />
						  Sensors5: {this.state.sensors5} <br />
                          Feet Level5: {this.state.feetLevel5} <br />
                          Water Level5: {this.state.waterLevel5} <br />
                          Description5: {this.state.description5} <br />
						  Sensors6: {this.state.sensors6} <br />
                          Feet Level6: {this.state.feetLevel6} <br />
                          Water Level6: {this.state.waterLevel6} <br />
                          Description6: {this.state.description6} <br />
						  Sensors7: {this.state.sensors7} <br />
                          Feet Level7: {this.state.feetLevel7} <br />
                          Water Level7: {this.state.waterLevel7} <br />
                          Description7: {this.state.description7} <br />
						  Sensors8: {this.state.sensors8} <br />
                          Feet Level8: {this.state.feetLevel8} <br />
                          Water Level8: {this.state.waterLevel8} <br />
                          Description8: {this.state.description8} <br />
						  Sensors9: {this.state.sensors9} <br />
                          Feet Level9: {this.state.feetLevel9} <br />
                          Water Level9: {this.state.waterLevel9} <br />
                          Description9: {this.state.description9} <br />
						  Sensors10: {this.state.sensors10} <br />
                          Feet Level10: {this.state.feetLevel10} <br />
                          Water Level10: {this.state.waterLevel10} <br />
                          Description10: {this.state.description10} <br />
                        </div>
                      </div>
                    </div>
                  </div>

                  <br />
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="kt-wizard-v1__review-item">
                        <div className="kt-wizard-v1__review-title">
                          Flow Meeter Details
                                                                </div>
                        <div className="kt-wizard-v1__review-content">
                          flow Meter Device Id : {this.state.flowMeterdeviceId} <br />
                          Power Backup Added : {this.state.powerBackupAdded} <br />
                          Power Backup Type : {this.state.powerBackupType} <br />
                          Power Backup Device Id : {this.state.powerBackupDeviceId} <br />

                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>

            {/* <!--end: Form Wizard Step 4--> */}

            {/* <!--begin: Form Actions --> */}
            <div className="kt-form__actions">
              <button className="btn btn-secondary btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u" data-ktwizard-type="action-prev" onClick={this.prevStep}>
                Previous
                                                    </button>
              <Button
                className="btn btn-success btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u"
                data-ktwizard-type="action-submit"
                onClick={this.submit} disabled={this.state.disableSubmit}
              >
                {this.state.disableSubmit ? 'Submitting' : 'Submit'}
              </Button>
              <button className="btn btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u" data-ktwizard-type="action-next" onClick={this.nextStep}>
                Next Step
                                                    </button>
            </div>

            {/* <!--end: Form Actions --> */}
          </form>

          {/* <!--end: Form Wizard Form--> */}
        </div>
      </div>
    </>
    );
  }
} 

export default TankCreate;